module.exports = __webpack_public_path__ + "img/ole.cd68bdf4.png";